import { ChevronRightIcon } from 'lucide-react';

import { type ITasksQuery } from 'src/graphql/actions/tasks/tasks.query';
import { type getTaskContent, type IPayload } from 'src/containers/Tasks';
import { Button } from '@/components/ui/button';

export type ITaskNode = ITasksQuery['tasks']['nodes'][number];

type Props = {
  task: ITaskNode;
  content: NonNullable<ReturnType<typeof getTaskContent>>;
  onSelect: (task: ITaskNode) => void;
};

const UnreadTaskRow = ({ task, content, onSelect }: Props) => {
  const { title, icon: Icon } = content;
  const payload = task.payload as IPayload | null;
  const appName = payload?.name;

  const handleClick = () => onSelect(task);

  return (
    <li>
      <Button
        variant="ghost"
        className="w-full items-center gap-2 px-1.5 py-1 text-left h-auto hover:bg-white"
        onClick={handleClick}
      >
        {Icon && <Icon className="size-4.5 shrink-0" />}
        <div className="min-w-0 grow">
          <p className="text-sm font-medium text-foreground truncate">{title}</p>
        </div>
        <span className="font-normal max-w-40 shrink-0 truncate text-xs text-muted-foreground">
          {appName || 'Untitled application'}
        </span>
        <ChevronRightIcon className="size-3.75! text-slate-400" />
      </Button>
    </li>
  );
};

export default UnreadTaskRow;
